import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { Spinner } from "@/components/ui-kit";

const TITLES = { eula: "End User License Agreement and Terms of Use", privacy: "Privacy Policy", key_terms: "Key terms at a glance" };

export default function LegalDoc() {
  const { doc } = useParams();
  const [legal, setLegal] = useState(null);
  useEffect(() => { api.get("/legal/clinician").then((r) => setLegal(r.data)).catch(() => setLegal({ error: true })); }, []);
  if (!legal) return <div className="min-h-screen grid place-items-center"><Spinner className="w-6 h-6" /></div>;
  return (
    <main className="min-h-screen bg-slate-50 px-4 py-10">
      <article className="mx-auto max-w-3xl rounded-2xl bg-white p-6 sm:p-10 shadow-sm border border-slate-100" data-testid={`legal-doc-${doc}`}>
        <p className="text-[12px] font-semibold uppercase tracking-wide text-slate-400">PranIQ Clinician Portal · Version {legal.version}</p>
        <h1 className="mt-1 text-2xl sm:text-3xl font-bold text-slate-900">{TITLES[doc] || "Document"}</h1>
        <div className="mt-6 whitespace-pre-wrap text-[14px] leading-7 text-slate-700" data-testid="legal-doc-text">{legal[doc] || "Document not found."}</div>
        <p className="mt-8 text-[11px] text-slate-400 break-all">Document hash (SHA-256): {legal.hash}</p>
      </article>
    </main>
  );
}
